import React from 'react';

import { IconFinanceFamily24, IconFinanceIT24, IconFinanceMortgage24 } from '@cian/ui-kit-design-tokens/icons';
import { IProgramCardProps } from 'shared/components/ProgramCard';
import {
  EBenefitProgram,
  IProgramsSummary,
} from 'shared/repositories/mortgage-broker-calculator/entities/get_settings/ProgramsSummary';

const PROGRAM_ICONS: Partial<Record<EBenefitProgram, React.ReactNode>> = {
  [EBenefitProgram.Family]: <IconFinanceFamily24 color="icon-inverted-default" />,
  [EBenefitProgram.It]: <IconFinanceIT24 color="icon-inverted-default" />,
  [EBenefitProgram.NoProgram]: <IconFinanceMortgage24 color="icon-inverted-default" />,
};

export const mapProgramsSummaryToProgramCards = (programsSummary: IProgramsSummary[]): IProgramCardProps[] =>
  programsSummary.map(({ benefitProgram, title, rate, loanTerm, loanAmount, downPayment }) => ({
    title,
    benefitProgram,
    rate,
    loanTerm,
    loanAmount,
    downPayment,
    icon: PROGRAM_ICONS[benefitProgram] ?? <IconFinanceMortgage24 color="icon-inverted-default" />,
  }));
